import ApplicationController from "./application_controller"

// Bridges donation-selector's dispatch-only "add-to-cart" event to the real backend.
export default class extends ApplicationController {
  static targets = ["addButton", "confirmation"]
  static values = {
    opportunityId: String,
    updateDonationUrl: String
  }

  connect() {
    super.connect()
    this.handleAddToCart = this.handleAddToCart.bind(this)
    this.element.addEventListener("donation-selector:add-to-cart", this.handleAddToCart)
  }

  disconnect() {
    this.element.removeEventListener("donation-selector:add-to-cart", this.handleAddToCart)
    clearTimeout(this.confirmationTimeout)
  }

  handleAddToCart(event) {
    const amount = event.detail.amount
    if (!amount || amount <= 0) return

    this.setLoading(true)

    fetch(this.updateDonationUrlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": this.csrfToken,
        "Accept": "application/json"
      },
      body: JSON.stringify({ amount, opportunity_id: this.opportunityIdValue })
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          document.dispatchEvent(new CustomEvent("cartUpdated", { bubbles: true, detail: { cart: data.cart } }))
          this.showConfirmation(amount)
        }
      })
      .catch(error => console.error("Error adding donation to cart:", error))
      .finally(() => this.setLoading(false))
  }

  setLoading(loading) {
    if (this.hasAddButtonTarget) this.addButtonTarget.disabled = loading
  }

  showConfirmation(amount) {
    if (!this.hasConfirmationTarget) return

    const formatted = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(amount)
    this.confirmationTarget.textContent = `${formatted} added to cart`
    this.confirmationTarget.classList.remove("d-none")

    clearTimeout(this.confirmationTimeout)
    this.confirmationTimeout = setTimeout(() => {
      this.confirmationTarget.classList.add("d-none")
    }, 3000)
  }

  get csrfToken() {
    const meta = document.querySelector('meta[name="csrf-token"]')
    return meta ? meta.content : ""
  }
}
